const previewContributions = [
  {
    url: 'https://ucarecdn.com/804697ce-7e8b-481d-9b4c-57b78bd9b066/',
    mediaId: '804697ce-7e8b-481d-9b4c-57b78bd9b066',
    type: 'image',
    width: 1470,
    height: 980,
    palette: [
      '#66626d',
      '#3b3d3e',
      '#e3d7d0',
      '#ba8f71',
      '#9c5d38',
    ],
    themePalette: [
      'convert',
      'favorite',
      'purple',
    ],
  },
  {
    url: 'https://ucarecdn.com/ddeae796-496a-40a4-a6a7-c928d3ef2c94/',
    mediaId: 'ddeae796-496a-40a4-a6a7-c928d3ef2c94',
    type: 'image',
    width: 1170,
    height: 878,
    palette: [
      '#524537',
      '#e0e1e1',
      '#2b251a',
      '#756d68',
      '#b0a096',
    ],
    themePalette: [
      'secondary',
      'favorite',
      'aqua',
    ],
  },
  {
    url: 'https://ucarecdn.com/8d91b2d1-0676-441b-a7e7-4a02e67ca93c/',
    mediaId: '8d91b2d1-0676-441b-a7e7-4a02e67ca93c',
    type: 'image',
    width: 1029,
    height: 580,
    palette: [
      '#271913',
      '#4d3c32',
      '#d6cfc9',
      '#906748',
      '#be9e86',
    ],
    themePalette: [
      'convert',
      'favorite',
      'purple',
    ],
  },
  {
    url: 'https://ucarecdn.com/7027004f-cfdb-402f-b5d9-c80b02128902/',
    mediaId: '7027004f-cfdb-402f-b5d9-c80b02128902',
    type: 'image',
    width: 1170,
    height: 780,
    palette: [
      '#524f69',
      '#694833',
      '#c6ada6',
      '#352d2f',
      '#8b7975',
    ],
    themePalette: [
      'inverted',
      'purple',
      'favorite',
    ],
  },
  {
    url: 'https://ucarecdn.com/e84199ba-55fc-4f88-a4c8-36793e204426/',
    mediaId: 'e84199ba-55fc-4f88-a4c8-36793e204426',
    type: 'image',
    width: 2560,
    height: 1706,
    palette: [
      '#981f1e',
      '#292127',
      '#d2d2d0',
      '#5b5456',
      '#898183',
    ],
    themePalette: [
      'purple',
      'inverted',
      'favorite',
    ],
  },
  {
    url: 'https://ucarecdn.com/1311b60b-3025-4b4f-8022-caed155d1875/',
    mediaId: '1311b60b-3025-4b4f-8022-caed155d1875',
    type: 'image',
    width: 700,
    height: 522,
    palette: [
      '#d5d5df',
      '#211919',
      '#5d4548',
      '#bf9c98',
      '#c14f51',
    ],
    themePalette: [
      'favorite',
      'purple',
      'convert',
    ],
  },
  {
    url: 'https://ucarecdn.com/7375bf19-a48c-4968-94d4-81ad987a48d6/',
    mediaId: '7375bf19-a48c-4968-94d4-81ad987a48d6',
    type: 'image',
    width: 1131,
    height: 1131,
    palette: [
      '#c5b4bf',
      '#212323',
      '#a7917a',
      '#72623e',
      '#ce5572',
    ],
    themePalette: [
      'favorite',
      'purple',
      'convert',
    ],
  },
  {
    url: 'https://ucarecdn.com/9cd564e0-1c8a-4af8-9c11-3727593d89dd/',
    mediaId: '9cd564e0-1c8a-4af8-9c11-3727593d89dd',
    type: 'image',
    width: 1170,
    height: 780,
    palette: [
      '#4b3d31',
      '#666f6d',
      '#121510',
      '#9f7953',
      '#b0a294',
    ],
    themePalette: [
      'inverted',
      'primary',
      'secondary',
    ],
  },
].map((mediaItem) => ({
  contribution: {
    _id: 'previewContribution',
    media: [mediaItem],
    title: 'Preview title of a Contribution',
    content: [{ _type: 'paragraph', children: [{ text: 'This is a preview description for a contribution' }] }],
    hashtags: ['#preview'],
  },
}));

previewContributions.random = function random() {
  return this[Math.floor(Math.random() * this.length)];
};

export default previewContributions;
